import { Component } from '@angular/core';
import { PreviewComponent } from "../preview.component";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: 'preview-app-root',
  standalone: true,
  imports: [ PreviewComponent, RouterOutlet ],
  template: `<router-outlet></router-outlet>`
})
export class PreviewAppComponent {
}
